import { OffersPushLine } from 'Components/lines/offers-push-line/OffersPushLine';
export default OffersPushLine;
